// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1gvTG","item-title":"Item_item-title__1gZul","item-content":"Item_item-content__3_3cL"};